/**
 * The configuration file for the angular.json file upgrading to Angular 15.
 */

export const replaces = {
    '"maximumWarning": "2mb"' : '"maximumWarning": "4mb"',
    '"builder": "@angular-devkit/build-ng-packagr:build"': '"builder": "@angular-devkit/build-angular:ng-packagr"',
    '"defaultCollection": "@angular-eslint/schematics"': '"analytics": false'
};

export const adds = [
    {
        toBeAdded: '"polyfills": ["zone.js", "zone.js/testing", "zone.js/dist/zone", "@msft-sme/core/polyfills"]',
        toBeAddedAfter: '"main": "src/test.ts"',
        indent: 12,
        keyword: '"polyfills": ["zone.js"'
    },
    {
        toBeAdded: '"polyfills": ["zone.js", "zone.js/testing", "zone.js/dist/zone", "@msft-sme/core/polyfills"]',
        toBeAddedAfter: '"codeCoverage": true',
        indent: 12,
        keyword: '"polyfills": ["zone.js"'
    },
    {
        toBeAdded: '"allowedCommonJsDependencies": ["chart.js"]',
        toBeAddedAfter: '"main": "src/main.ts"',
        indent: 12,
        keyword: '"allowedCommonJsDependencies": ["chart.js"]',
    }
];

export const removes = [
    {
        key: 'customWebpackConfig',
        linesInTotalAfterKey: 4,
        exactMatch: false
    },
    {
        key: '"extractCss": true,'
    },
    {
        key: '"polyfills": "src/polyfills.ts",',
        toBeRemovedAfter: '"main": "src/test.ts"'
    },
    {
        key: '"main": "src/test.ts",'
    },
    {
        key: '"defaultProject"',
    },
    {
        key: '"analytics": false",'
    }
]
